module.exports = __webpack_public_path__ + "img/0Q3A9771_FoamcoreMatted.4aa3aab2.jpg";